import { atom } from 'recoil';

export const subAccountsSearchFilterState = atom<string | undefined>({
  key: 'app.subAccounts.search.filter',
  default: undefined,
});
